import React from "react";
import { Link } from "react-router-dom";
import PhoneLink from "./PhoneLink";
import blogData from "../data/blogData";

const Footer = () => {
  const recentPosts = blogData.slice(0, 5);

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1: Menu Links */}
        <div className="footer-column">
          <h4>Menu Links</h4>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/our-tax-services">Services</Link>
            </li>
            <li>
              <Link to="/state-tax-guide">State Tax Guide</Link>
            </li>
            <li>
              <Link to="/tax-faqs">Tax FAQs</Link>
            </li>
            <li>
              <Link to="/about-us">About Us</Link>
            </li>
            <li>
              <Link to="/tax-news">Tax News</Link>
            </li>
            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
          </ul>
        </div>

        {/* Column 2: Logo & Address */}
        <div className="footer-column center">
          <img
            src="/images/tax-advocate-group-logo-small.png"
            alt="Tax Advocate Group Logo"
            className="footer-logo"
          />
          <p>
            <strong>Tax Advocate Group</strong>
          </p>
          <p>21625 Prairie Street, Suite #200</p>
          <p>Chatsworth, CA 91331</p>
          <p>
            <PhoneLink rawNumber="18005171807" />
          </p>
        </div>

        {/* Column 3: Recent Posts (dynamic) */}
        <div className="footer-column">
          <h4>Recent Posts</h4>
          <ul>
            {recentPosts.map((post) => (
              <li key={post.id}>
                <Link to={`/tax-news/${post.id}`}>{post.title}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Bottom Disclaimer */}
      <div className="footer-bottom">
        <p className="footer-disclaimer">
          By clicking "SUBSCRIBE" or "SUBMIT," I agree to be contacted by Tax
          Advocate Group and its affiliates via prerecorded and/or telemarketing
          calls and/or SMS/MMS text messages...
        </p>
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Tax Advocate Group, LLC. All Rights Reserved. |
          <Link to="/privacy-policy"> Privacy Policy</Link> |
          <Link to="/terms-of-service"> Terms of Service</Link> |
        </p>
      </div>
    </footer>
  );
};

export default Footer;
